import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconPublish(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 4C3 2.89543 3.89543 2 5 2H17C19.2091 2 21 3.79086 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V4ZM13 20V12.4142L14.2929 13.7071C14.6834 14.0976 15.3166 14.0976 15.7071 13.7071C16.0976 13.3166 16.0976 12.6834 15.7071 12.2929L12.7071 9.29289C12.3166 8.90237 11.6834 8.90237 11.2929 9.29289L8.29289 12.2929C7.90237 12.6834 7.90237 13.3166 8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071L11 12.4142V20H5V4L14 4V7C14 8.10457 14.8954 9 16 9H19V20H13ZM17 4C18.1046 4 19 4.89543 19 6V7H16V4H17Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
